import { Input } from 'common/ui/input';

// A one-time code field. Authenticator codes are 6 digits; with
// allowBackupCode it also takes a backup code (e.g. "abcde-fghjk").
export default function TwoFactorCodeInput({
  value,
  onChange,
  allowBackupCode = false,
  autoFocus = true,
  disabled,
}: {
  value: string;
  onChange: (value: string) => void;
  allowBackupCode?: boolean;
  autoFocus?: boolean;
  disabled?: boolean;
}) {
  return (
    <Input
      value={value}
      onChange={e =>
        onChange(
          allowBackupCode
            ? e.target.value.replace(/\s/g, '')
            : e.target.value.replace(/\D/g, '').slice(0, 6)
        )
      }
      placeholder={allowBackupCode ? 'Mã 6 số hoặc mã dự phòng' : 'Mã 6 số'}
      inputMode={allowBackupCode ? 'text' : 'numeric'}
      autoComplete="one-time-code"
      autoCapitalize="off"
      spellCheck={false}
      maxLength={allowBackupCode ? 32 : 6}
      autoFocus={autoFocus}
      disabled={disabled}
      className="font-mono tracking-widest"
      required
    />
  );
}
